import ce, { memo as V, useReducer as qe, useCallback as O, useEffect as L, useState as E, useMemo as F, useContext as M, createContext as qt } from "react";
import { useNavigate as Gt, Routes as ht, Route as q } from "react-router-dom";
import { SimpleRedirectBlock as Bt, FormActionsContainer as H, FormElement as I, NAME_COLUMN as Ae, ActionCell as xe, ListHeaderSecondary as Te, PageList as fe, ListCell as Ee, SpinnerWidgetContainer as yt, DataSourceLabel as Wt, BaseContentWrapper as Kt, BaseInfoWrapper as Vt, ListHeaderPrimary as Ht, TabsNavigationNew as Yt, BaseEntityContent as Jt, DATE_COLUMN as Xt, AUTHOR_COLUMN as Zt, parseMessageEntity as Qt, SpinnerContainer as en } from "@prometheus/features";
import { Grid as u, Input as G, Button as v, Icon as _, Block as X, Select as ne, Spinner as Z, CheckboxCell as me, Tooltip as je, IconActionButton as Ge, useNotifications as z, NewTable as le, Box as tn, Autocomplete as gt, Typography as he, Alert as nn, Divider as Ne, Checkbox as $e, StatusTag as st, Textarea as sn } from "@prometheus/components";
import { Status as w, AuditLogsAction as an } from "@prometheus/types";
import { ModalContext as ae, useMetadata as rn, useRequest as on, useDownloadAnalysisTypes as cn } from "@prometheus/hooks";
import { api as b, getSortDirection as Se, parseFiltersToStringParams as ln, downloadFile as dn, getReducerWithProduce as Be, getUUID as J, convertOptionsAttributeListToObjectOptionsAttribute as un, convertObjectOptionsAttributeToOptionsAttributeList as pn, isEmpty as xt, uniq as mn, createSortingMethodListConfig as we, createFiltersPanelListConfig as ve, createCrudMethodsListConfig as _e, compact as at, getAccessTypeBadgeColor as hn, getExecutionPolicyBadgeColor as yn, reverse as gn, difference as xn } from "@prometheus/utils";
import { EntityType as We, MetaAttributeTypes as ye, metaAttributesTypes as Tt, entityTypes as jt, EntityTypes as Ke, DataSourceAccessType as ze, DataSourceModelTypes as Tn } from "@prometheus/enums";
import { useSelector as Ve, useDispatch as Q } from "react-redux";
import { setBreadcrumbs as ee } from "@prometheus/redux";
import jn from "@emotion/styled";
import { useTheme as rt } from "@emotion/react";
var Ue = { exports: {} }, ue = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ot;
function Sn() {
  if (ot) return ue;
  ot = 1;
  var e = Symbol.for("react.transitional.element"), s = Symbol.for("react.fragment");
  function n(a, r, c) {
    var o = null;
    if (c !== void 0 && (o = "" + c), r.key !== void 0 && (o = "" + r.key), "key" in r) {
      c = {};
      for (var i in r)
        i !== "key" && (c[i] = r[i]);
    } else c = r;
    return r = c.ref, {
      $$typeof: e,
      type: a,
      key: o,
      ref: r !== void 0 ? r : null,
      props: c
    };
  }
  return ue.Fragment = s, ue.jsx = n, ue.jsxs = n, ue;
}
var pe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function Cn() {
  return it || (it = 1, process.env.NODE_ENV !== "production" && function() {
    function e(y) {
      if (y == null) return null;
      if (typeof y == "function")
        return y.$$typeof === zt ? null : y.displayName || y.name || null;
      if (typeof y == "string") return y;
      switch (y) {
        case T:
          return "Fragment";
        case j:
          return "Profiler";
        case S:
          return "StrictMode";
        case R:
          return "Suspense";
        case W:
          return "SuspenseList";
        case $t:
          return "Activity";
      }
      if (typeof y == "object")
        switch (typeof y.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), y.$$typeof) {
          case x:
            return "Portal";
          case A:
            return (y.displayName || "Context") + ".Provider";
          case g:
            return (y._context.displayName || "Context") + ".Consumer";
          case N:
            var f = y.render;
            return y = y.displayName, y || (y = f.displayName || f.name || "", y = y !== "" ? "ForwardRef(" + y + ")" : "ForwardRef"), y;
          case re:
            return f = y.displayName || null, f !== null ? f : e(y.type) || "Memo";
          case Je:
            f = y._payload, y = y._init;
            try {
              return e(y(f));
            } catch {
            }
        }
      return null;
    }
    function s(y) {
      return "" + y;
    }
    function n(y) {
      try {
        s(y);
        var f = !1;
      } catch {
        f = !0;
      }
      if (f) {
        f = console;
        var D = f.error, P = typeof Symbol == "function" && Symbol.toStringTag && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return D.call(
          f,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          P
        ), s(y);
      }
    }
    function a(y) {
      if (y === T) return "<>";
      if (typeof y == "object" && y !== null && y.$$typeof === Je)
        return "<...>";
      try {
        var f = e(y);
        return f ? "<" + f + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var y = Ie.A;
      return y === null ? null : y.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function o(y) {
      if (Xe.call(y, "key")) {
        var f = Object.getOwnPropertyDescriptor(y, "key").get;
        if (f && f.isReactWarning) return !1;
      }
      return y.key !== void 0;
    }
    function i(y, f) {
      function D() {
        Ze || (Ze = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          f
        ));
      }
      D.isReactWarning = !0, Object.defineProperty(y, "key", {
        get: D,
        configurable: !0
      });
    }
    function d() {
      var y = e(this.type);
      return Qe[y] || (Qe[y] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), y = this.props.ref, y !== void 0 ? y : null;
    }
    function p(y, f, D, P, te, K, De, Re) {
      return D = K.ref, y = {
        $$typeof: h,
        type: y,
        key: f,
        props: K,
        _owner: te
      }, (D !== void 0 ? D : null) !== null ? Object.defineProperty(y, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(y, "ref", { enumerable: !1, value: null }), y._store = {}, Object.defineProperty(y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(y, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(y, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: De
      }), Object.defineProperty(y, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Re
      }), Object.freeze && (Object.freeze(y.props), Object.freeze(y)), y;
    }
    function m(y, f, D, P, te, K, De, Re) {
      var $ = f.children;
      if ($ !== void 0)
        if (P)
          if (Ut($)) {
            for (P = 0; P < $.length; P++)
              C($[P]);
            Object.freeze && Object.freeze($);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else C($);
      if (Xe.call(f, "key")) {
        $ = e(y);
        var ie = Object.keys(f).filter(function(Ft) {
          return Ft !== "key";
        });
        P = 0 < ie.length ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}", nt[$ + P] || (ie = 0 < ie.length ? "{" + ie.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          P,
          $,
          ie,
          $
        ), nt[$ + P] = !0);
      }
      if ($ = null, D !== void 0 && (n(D), $ = "" + D), o(f) && (n(f.key), $ = "" + f.key), "key" in f) {
        D = {};
        for (var ke in f)
          ke !== "key" && (D[ke] = f[ke]);
      } else D = f;
      return $ && i(
        D,
        typeof y == "function" ? y.displayName || y.name || "Unknown" : y
      ), p(
        y,
        $,
        K,
        te,
        r(),
        D,
        De,
        Re
      );
    }
    function C(y) {
      typeof y == "object" && y !== null && y.$$typeof === h && y._store && (y._store.validated = 1);
    }
    var l = ce, h = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), j = Symbol.for("react.profiler"), g = Symbol.for("react.consumer"), A = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), W = Symbol.for("react.suspense_list"), re = Symbol.for("react.memo"), Je = Symbol.for("react.lazy"), $t = Symbol.for("react.activity"), zt = Symbol.for("react.client.reference"), Ie = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Xe = Object.prototype.hasOwnProperty, Ut = Array.isArray, Oe = console.createTask ? console.createTask : function() {
      return null;
    };
    l = {
      react_stack_bottom_frame: function(y) {
        return y();
      }
    };
    var Ze, Qe = {}, et = l.react_stack_bottom_frame.bind(
      l,
      c
    )(), tt = Oe(a(c)), nt = {};
    pe.Fragment = T, pe.jsx = function(y, f, D, P, te) {
      var K = 1e4 > Ie.recentlyCreatedOwnerStacks++;
      return m(
        y,
        f,
        D,
        !1,
        P,
        te,
        K ? Error("react-stack-top-frame") : et,
        K ? Oe(a(y)) : tt
      );
    }, pe.jsxs = function(y, f, D, P, te) {
      var K = 1e4 > Ie.recentlyCreatedOwnerStacks++;
      return m(
        y,
        f,
        D,
        !0,
        P,
        te,
        K ? Error("react-stack-top-frame") : et,
        K ? Oe(a(y)) : tt
      );
    };
  }()), pe;
}
process.env.NODE_ENV === "production" ? Ue.exports = Sn() : Ue.exports = Cn();
var t = Ue.exports;
const bn = {
  title: "Settings",
  iconName: "admin",
  url: "/admin",
  description: "Application administration, including tenants, roles, data sets, meta data and more.",
  titleButton: "Go to admin panel"
}, An = V((e) => {
  const { name: s } = e, n = Gt(), { title: a, iconName: r, url: c, description: o, titleButton: i } = bn;
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: s === "home-widget" && /* @__PURE__ */ t.jsx(
    Bt,
    {
      ...e,
      title: a,
      iconName: r,
      onClick: () => n(c),
      description: o,
      buttonName: i
    }
  ) });
}), ge = (e) => String(e).replace(/[_\s-]/g, "").toLowerCase(), se = (e) => {
  if (typeof e == "boolean")
    return e;
  if (Array.isArray(e))
    return e.some((n) => {
      const a = ge(n);
      return a.includes("datasteward") || a.includes("steward") || a.includes("owner");
    });
  if (typeof e == "string") {
    const n = ge(e);
    return n.includes("datasteward") || n.includes("steward") || n.includes("owner");
  }
  const s = e;
  return !!((s == null ? void 0 : s.dataSteward) ?? (s == null ? void 0 : s.steward) ?? (s == null ? void 0 : s.owner));
}, de = (e, s) => Array.isArray(s) && s.some((a) => ge(a) === "admin") ? !0 : typeof e == "boolean" ? e : Array.isArray(e) ? e.some((a) => ge(a).includes("admin")) : typeof e == "string" ? ge(e).includes("admin") : !!(e != null && e.admin), fn = (e) => {
  var n;
  const s = se(e.roles);
  return {
    steward: s,
    dataSteward: s,
    owner: !!(((n = e.roles) == null ? void 0 : n.owner) ?? s),
    admin: de(e.roles)
  };
}, Ce = (e, s) => async (n, a) => {
  var r;
  try {
    const c = n.added.map((d) => d.object.id), o = n.deleted.map((d) => d.id), i = n.added.reduce(
      (d, p) => (d[p.object.id] = fn(p), d),
      {}
    );
    return c.length > 0 && await s.add(c, a, i), o.length > 0 && await s.delete(o), s.update && ((r = n.updated) != null && r.length) && await s.update(n.updated, a), {
      message: `${e} list successfully modified for selected group`
    };
  } catch (c) {
    return {
      message: "Something went wrong",
      error: c
    };
  }
}, En = (e) => b.get(`/admin/metadata-attribute/${e}/tenant`), Nn = (e, s) => b.post(`/datasource/${e}/tenant/${s}`), wn = (e) => b.delete(`/datasource/tenant/${e}`), St = (e, s) => b.post(`/users/${e}/tenant/${s}`), vn = (e) => b.delete(`/users/tenant/${e}`), Ct = (e, s, n) => b.put(
  `/users/${e}/tenant/${s}/data-steward`,
  JSON.stringify(n),
  { headers: { "Content-Type": "application/json" } }
), bt = (e, s, n) => b.put(
  `/users/${e}/tenant/${s}/admin`,
  JSON.stringify(n),
  {
    headers: { "Content-Type": "application/json" }
  }
), At = (e, s) => b.post(`/admin/metadata-attribute/${e}/tenant/${s}`), _n = (e) => b.delete(`/admin/metadata-attribute/tenant/${e}`), Ln = (e, s) => Promise.all(e.map((n) => Nn(n, s))), In = (e) => Promise.all(e.map(wn)), ft = (e, s, n) => Promise.all(
  e.map(async (a) => {
    const r = n == null ? void 0 : n[a];
    se(r) ? await Ct(a, s, !0) : await St(a, s), de(r) && await bt(a, s, !0);
  })
), Et = (e) => Promise.all(e.map(vn)), Nt = (e, s) => Promise.all(
  e.flatMap((n) => {
    var r, c, o, i;
    const a = [];
    return ((r = n.roleChanges) != null && r.steward || (c = n.roleChanges) != null && c.dataSteward || (o = n.roleChanges) != null && o.owner) && a.push(
      Ct(
        n.object.id,
        s,
        se(n.roles)
      )
    ), (i = n.roleChanges) != null && i.admin && a.push(
      bt(
        n.object.id,
        s,
        de(n.roles)
      )
    ), a;
  })
), On = (e, s) => Promise.all(e.map((n) => At(n, s))), Dn = (e) => Promise.all(e.map(_n)), Rn = (e) => b.post(`/users/tenant/${e}/active`), kn = () => b.get("/tenant"), Mn = (e, s) => b.post(`/tenant${s ? "/" + s : ""}`, e), Pn = (e, s) => b.put(`/tenant/${e}`, s), $n = (e) => b.delete(`/tenant/${e}`), wt = (e) => b.get(`/tenant/${e}/analysis-types`), vt = (e, s) => b.put(`/tenant/${e}/analysis-types`, s), zn = (e) => {
  const { pageNumber: s, pageSize: n, sortBy: a, query: r } = e, c = Se(a), o = `/admin/metadata-attribute/list?${r || ""}&size=${n || ""}&page=${s || ""}&sort=${c}&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=COHORT&filter.metadata.subject=CONCEPT_SET`;
  return b.get(o);
}, Un = (e) => b.post(`/${We.ADMIN}/metadata-attribute`, e), Fn = (e, s) => b.put(`/${We.ADMIN}/metadata-attribute/${e}`, s), qn = (e) => b.delete(`/${We.ADMIN}/metadata-attribute/${e}`), Gn = (e) => b.get(`/admin/metadata-attribute/tenant/${e}`), _t = (e) => {
  const { pageNumber: s, pageSize: n, sortBy: a, query: r } = e, c = Se(a), o = `/users/admin/list?${r || ""}&size=${n || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, Bn = (e) => {
  const s = `/users/tenant/${e}/candidate`;
  return b.get(s);
}, Lt = (e) => b.get(`/users/tenant/${e}`), Wn = (e) => {
  const s = `/users/admin/filter?${e}`;
  return b.get(s);
}, Kn = () => b.get("/users/admin/sorts"), Vn = () => b.get("/study-types"), Hn = (e) => b.post("/study-types", e), Yn = (e) => b.get(`/study-types/${e}`), Jn = (e) => b.get(`/study-types/${e}/consent`), Xn = (e, s) => b.put(`/study-types/${e}`, s), It = (e, s) => b.post(`/study-types/${e}/consent`, s), Zn = async (e) => {
  try {
    const s = await Hn(e);
    return await It(s.id, {
      text: e.requireUserConsentMessage,
      required: e.requireUserConsent
    }), {
      ...s,
      requireUserConsent: e.requireUserConsent,
      requireUserConsentMessage: e.requireUserConsentMessage
    };
  } catch (s) {
    return console.error(s), null;
  }
}, Qn = async (e, s) => {
  try {
    const n = await Xn(e, s);
    return await It(n.id, {
      text: s.requireUserConsentMessage,
      required: s.requireUserConsent
    }), {
      ...n,
      requireUserConsent: s.requireUserConsent,
      requireUserConsentMessage: s.requireUserConsentMessage
    };
  } catch (n) {
    return console.error(n), null;
  }
}, es = (e) => b.delete(`/study-types/${e}`), Ot = () => b.get("/model-type"), ts = (e) => b.get(`/model-type/${e}`), ns = (e, s) => b.put(`/model-type/${e}`, s), ss = (e) => b.delete(`/model-type/${e}`), as = (e, s) => b.put(`/analysis/types/model-types/${e}`, s), rs = (e, s) => b.delete(`/analysis/types/${e}/model-types/${s}`), os = (e) => {
  const { pageNumber: s, pageSize: n, sortBy: a, query: r } = e, c = Se(a), o = `/audit/events/list?${r || ""}&size=${n || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, is = (e) => {
  const n = `/audit/events/export/csv?${ln(e) || ""}`;
  b.get(n).then((a) => dn(a, "audit-logs.csv", "text/csv"));
}, cs = (e) => b.get(`/audit/events/filter?${e}`), ls = () => b.get("/audit/events/sorts"), ds = () => b.get("/modules"), us = (e) => b.put("/modules", e), ps = (e) => b.post("/modules/restart", e);
var Y = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_OPTION = "ADD_OPTION", e.CHANGE_OPTION = "CHANGE_OPTION", e.REMOVE_OPTION = "REMOVE_OPTION", e))(Y || {});
const ms = {
  isStartHook: !1,
  isLoading: !1,
  options: {}
}, hs = (e, s) => Be(e, (n) => {
  switch (s.type) {
    case Y.INIT:
      n.options = s.payload;
      break;
    case Y.ADD_OPTION:
      n.options[s.payload.id] = s.payload.value;
      break;
    case Y.CHANGE_OPTION:
      n.options[s.payload.id] = s.payload.value;
      break;
    case Y.REMOVE_OPTION:
      const a = { ...n.options };
      delete a[s.payload], n.options = a;
      break;
  }
}), ys = (e) => {
  const [s, n] = qe(
    hs,
    ms
  ), a = O(() => {
    const o = J();
    n({
      type: Y.ADD_OPTION,
      payload: {
        id: o,
        value: {
          value: ""
        }
      }
    });
  }, []), r = O(
    (o, i, d) => {
      n({
        type: Y.CHANGE_OPTION,
        payload: {
          id: o,
          value: {
            ...s.options[o],
            [i]: d
          }
        }
      });
    },
    [s.options]
  ), c = O((o) => {
    n({
      type: Y.REMOVE_OPTION,
      payload: o
    });
  }, []);
  return L(() => {
    e.length > 0 ? n({
      type: Y.INIT,
      payload: un(e)
    }) : a();
  }, []), {
    ...s,
    addOption: a,
    changeOption: r,
    removeOption: c
  };
};
var k = /* @__PURE__ */ ((e) => (e.GET_LIST_TENANTS = "GET_LIST_TENANTS", e.GET_LIST_TENANTS_DONE = "GET_LIST_TENANTS_DONE", e.GET_LIST_TENANTS_FAILED = "GET_LIST_TENANTS_FAILED", e.ADD_TO_TENANT = "ADD_TO_TENANT", e.ADD_TO_TENANT_DONE = "ADD_TO_TENANT_DONE", e.ADD_TO_TENANT_FAILED = "ADD_TO_TENANT_FAILED", e.SET_ACTIVE = "SET_ACTIVE", e.SET_ACTIVE_DONE = "SET_ACTIVE_DONE", e.SET_ACTIVE_FAILED = "SET_ACTIVE_FAILED", e.UPDATE_TENANT = "UPDATE_TENANT", e.UPDATE_GROUP = "UPDATE_GROUP", e.DELETE_GROUP = "DELETE_GROUP", e))(k || {}), oe = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LIST_LOADING = "LIST_LOADING", e.LIST_LOADED = "LIST_LOADED", e.ADD_TENANT_LOADING = "ADD_TENANT_LOADING", e.ADD_TENANT_LOADED = "ADD_TENANT_LOADED", e))(oe || {});
const gs = {
  tenants: [],
  groups: [],
  activeTenant: null,
  status: oe.INITIAL,
  error: {}
}, xs = (e, s) => Be(e, (n) => {
  switch (s.type) {
    case k.GET_LIST_TENANTS:
      n.status = oe.LIST_LOADING, n.tenants = [], n.groups = [];
      break;
    case k.GET_LIST_TENANTS_DONE:
      n.tenants = s.payload.tenants, n.groups = s.payload.groups, n.status = oe.LIST_LOADED;
      break;
    case k.UPDATE_GROUP:
      {
        const a = n.groups.findIndex(
          (r) => r.id === s.payload.id
        );
        a !== -1 ? n.groups.splice(a, 1, s.payload) : n.groups.unshift(s.payload);
      }
      break;
    case k.UPDATE_TENANT:
      {
        const a = n.tenants.findIndex(
          (r) => r.id === s.payload.id
        );
        a !== -1 ? n.tenants.splice(a, 1, s.payload) : n.tenants.unshift(s.payload);
      }
      break;
    case k.DELETE_GROUP:
      {
        const a = n.groups.findIndex(
          (r) => r.id === s.payload
        );
        n.groups.splice(a, 1);
      }
      break;
    case k.ADD_TO_TENANT:
      n.status = oe.ADD_TENANT_LOADING;
      break;
    case k.ADD_TO_TENANT_DONE:
      n.status = oe.ADD_TENANT_LOADED;
  }
}), He = (e, s, n = "USERS") => {
  const [a, r] = qe(xs, gs), c = O(async () => {
    r({
      type: k.GET_LIST_TENANTS
    });
    try {
      const l = await kn();
      r({
        type: k.GET_LIST_TENANTS_DONE,
        payload: {
          tenants: l.filter((h) => !h.parent).map((h) => ({
            ...h,
            active: e.activeTenant === h.id
          })),
          groups: l.filter(
            (h) => h.parent && !h.terminated
          )
        }
      });
    } catch {
      r({
        type: k.GET_LIST_TENANTS_FAILED
      });
    }
  }, []), o = (l) => {
    r({
      type: k.UPDATE_GROUP,
      payload: l
    });
  }, i = (l) => {
    r({
      type: k.DELETE_GROUP,
      payload: l
    });
  }, d = (l) => {
    r({
      type: k.UPDATE_TENANT,
      payload: l
    });
  }, p = O(async (l) => {
    r({
      type: k.ADD_TO_TENANT
    });
    const h = [];
    l.forEach((x) => {
      h.push(
        n === "USERS" ? St(s.id, x) : At(s.id, x)
      );
    });
    try {
      await Promise.all(h), r({
        type: k.ADD_TO_TENANT_DONE
      });
    } catch {
    }
  }, []), m = O(() => {
  }, []), C = O(async (l) => {
    r({
      type: k.SET_ACTIVE
    });
    try {
      await Rn(l), r({
        type: k.SET_ACTIVE_DONE
      });
    } catch {
    }
  }, []);
  return L(() => {
    c();
  }, [e.id]), {
    ...a,
    updateGroups: o,
    updateTenant: d,
    deleteGroups: i,
    setActiveTenant: C,
    getTenants: c,
    addEntityToTenant: p,
    removeTenant: m
  };
};
var Dt = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LOADING_LIST = "LOADING_LIST", e.LOADED_LIST = "LOADED_LIST", e.FAILED_LOADED_LIST = "FAILED_LOADED_LIST", e.CREATING_USER = "CREATING_USER", e.CREATED_USER = "CREATED_USER", e))(Dt || {});
Dt.INITIAL;
const Ts = (e) => {
  const { initOptions: s, onChange: n } = e, { options: a, addOption: r, removeOption: c, changeOption: o } = ys(s);
  return L(() => {
    n(pn(a));
  }, [a]), /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 1, children: [
    Object.keys(a).map((i) => {
      const d = a[i];
      return /* @__PURE__ */ t.jsxs(
        u,
        {
          item: !0,
          xs: 12,
          container: !0,
          spacing: 2,
          alignItems: "center",
          classes: {
            root: "metadata-attribute-option"
          },
          children: [
            /* @__PURE__ */ t.jsx(u, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              G,
              {
                id: "value",
                name: "value",
                type: "text",
                size: "medium",
                placeholder: "Enter option",
                value: d.value,
                onChange: (p) => o(i, "value", p.target.value),
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ t.jsx(u, { item: !0, children: /* @__PURE__ */ t.jsx(
              v,
              {
                disabled: Object.keys(a).length === 1,
                onClick: () => {
                  c(i);
                },
                size: "small",
                sx: { minWidth: 0 },
                children: /* @__PURE__ */ t.jsx(
                  _,
                  {
                    iconName: "delete",
                    fontSize: "small",
                    color: Object.keys(a).length === 1 ? "disabled" : "error"
                  }
                )
              }
            ) })
          ]
        },
        i
      );
    }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(H, { children: /* @__PURE__ */ t.jsx(
      v,
      {
        onClick: r,
        variant: "text",
        startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "add" }),
        sx: { textDecoration: "underline" },
        className: "add-option",
        children: "Add new option"
      }
    ) }) })
  ] });
}, ct = V((e) => {
  const { onClose: s, onAdd: n, values: a, isUpdate: r, onUpdate: c } = e, [o, i] = E(!1), [d, p] = E({
    title: (a == null ? void 0 : a.name) || "",
    type: (a == null ? void 0 : a.type) || ye.STRING,
    options: (a == null ? void 0 : a.options) || [],
    metadataSubjects: (a == null ? void 0 : a.metadataSubjects) || []
  }), m = O(async () => {
    i(!0), r ? c(d, a) : n({
      id: J(),
      ...d
    }), s();
  }, [d]), C = F(() => {
    const l = d.options.find(
      (h) => xt(h.value)
    );
    return !!(!d.title || !d.type || l || d.metadataSubjects.length == 0);
  }, [d]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        placeholder: "Enter title",
        value: d.title,
        onChange: (l) => {
          p((h) => ({ ...h, title: l.target.value }));
        },
        fullWidth: !0,
        required: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(I, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: Tt,
        value: d.type,
        placeholder: "Select type",
        onChange: (l) => {
          p({ ...d, type: l });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(I, { name: "subject", textLabel: "Subject", required: !0, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        className: "",
        name: "subject",
        disablePortal: !0,
        id: "subject",
        multiple: !0,
        options: jt,
        value: d.metadataSubjects,
        placeholder: "Select subject",
        onChange: (l) => {
          p({ ...d, metadataSubjects: l });
        },
        fullWidth: !0
      }
    ) }) }),
    (ye.ENUM == d.type || ye.ENUM_MULTI == d.type) && /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "options", textLabel: "Options", required: !0, children: /* @__PURE__ */ t.jsx(
      Ts,
      {
        initOptions: d.options,
        onChange: (l) => {
          p({
            ...d,
            options: l
          });
        }
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          disabled: o || C,
          onClick: m,
          variant: "contained",
          color: "success",
          startIcon: o ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), Me = {
  entityBreadcrumb: (e) => [
    {
      name: "Settings",
      path: `${e}`
    },
    {
      name: "Metadata",
      path: `${e}/metadata`
    }
  ],
  filterMetadata: "&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=CONCEPT_SET&filter.metadata.subject=COHORT",
  createCols: (e, s) => [
    Ae({ minSize: 200 }),
    {
      header: "Type of value",
      accessorKey: "type",
      cell: (n) => Tt.find(
        (a) => a.value == n.getValue()
      ).name
    },
    {
      header: "Subjects",
      accessorKey: "metadataSubjects",
      isCropped: !0,
      enableSorting: !1,
      maxWidth: 200,
      cell: (n) => mn(n.getValue()).map((a) => {
        var r;
        return (r = jt.find((c) => c.value === a)) == null ? void 0 : r.name;
      }).join(", ")
    },
    {
      header: "Values",
      accessorKey: "options",
      size: 100,
      maxSize: 100,
      cell: (n) => {
        var r;
        const a = n.row.original.type;
        return a === ye.ENUM || a === ye.ENUM_MULTI ? /* @__PURE__ */ t.jsx(t.Fragment, { children: (r = n.row.original.options) == null ? void 0 : r.length }) : /* @__PURE__ */ t.jsx(t.Fragment, { children: "-" });
      }
    },
    {
      header: "Required",
      accessorKey: "required",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Searchable",
      accessorKey: "searchable",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Filter display",
      accessorKey: "filterable",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "Table display",
      accessorKey: "visible",
      enableSorting: !1,
      meta: { align: "center", headerAlign: "center" },
      cell: me,
      size: 90,
      maxSize: 90
    },
    {
      header: "",
      accessorKey: "id",
      enableSorting: !1,
      size: 90,
      maxSize: 90,
      meta: { columnType: "action" },
      cell: (n) => /* @__PURE__ */ t.jsx(
        xe,
        {
          entityType: n.row.original.name,
          withConfirmation: !0,
          onRemove: () => e(n.row.original.id),
          children: /* @__PURE__ */ t.jsx(je, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
            Ge,
            {
              iconName: "add",
              color: "default",
              size: "small",
              noExpand: !0,
              onClick: (a) => {
                a.stopPropagation(), s(n.row.original);
              }
            }
          ) }) })
        }
      )
    }
  ]
}, Ye = V((e) => {
  var x;
  const { onClose: s, user: n, typeEntity: a } = e, { enqueueSnackbar: r } = z(), [c, o] = E(!1), [i, d] = E({
    tenants: []
  }), p = Ve(
    (T) => T.user
  ), { tenants: m, status: C, addEntityToTenant: l } = He(
    p.data,
    n,
    a
  );
  L(() => {
    C === oe.ADD_TENANT_LOADED && (o(!1), r({
      message: "User added to tenant",
      variant: "success"
    }));
  }, [C]);
  const h = O(async () => {
    o(!0);
    try {
      await l(i.tenants);
    } catch {
      o(!1);
    }
    s();
  }, [i]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "tenants", textLabel: "Your tenants", children: ((x = n.tenants) == null ? void 0 : x.length) > 0 ? n.tenants.map((T) => /* @__PURE__ */ t.jsx("p", { children: T.object.title })) : /* @__PURE__ */ t.jsx("p", { children: "-" }) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "tenants", textLabel: "Tenants", required: !0, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        className: "",
        name: "tenants",
        disablePortal: !0,
        id: "proType",
        options: m.filter((T) => {
          var S;
          return !((S = n == null ? void 0 : n.tenants) != null && S.includes(T.id));
        }).map((T) => ({
          value: T.id,
          name: T.title
        })),
        value: i.tenants,
        placeholder: "Select tenants",
        multiple: !0,
        onChange: (T) => {
          d({
            ...i,
            tenants: T
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          disabled: c,
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          onClick: h,
          disabled: c || i.tenants.length === 0,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), js = () => {
  const e = Q(), { openModal: s, closeModal: n } = M(ae), { path: a } = M(
    B
  ), [r, c] = E(), { enqueueSnackbar: o } = z();
  L(() => {
    e(ee(Me.entityBreadcrumb(a)));
  }, [a]);
  const {
    data: i,
    addAttribute: d,
    updateAttribute: p,
    editAttribute: m,
    removeAttribute: C,
    isLoading: l,
    changeMessage: h
  } = rn(
    Me.filterMetadata,
    !1,
    !0,
    Un,
    Fn,
    qn
  ), x = async (g) => {
    const A = await En(g.id);
    s(
      () => /* @__PURE__ */ t.jsx(
        Ye,
        {
          user: {
            ...g,
            tenants: A
          },
          typeEntity: Ke.METADATA,
          onClose: () => {
            c(J()), n();
          }
        }
      ),
      "Add meta attribute to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, T = () => {
    s(
      () => /* @__PURE__ */ t.jsx(
        ct,
        {
          onAdd: d,
          onClose: n,
          isLoading: l
        }
      ),
      "Add attribute",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, S = (g) => {
    s(
      () => /* @__PURE__ */ t.jsx(
        ct,
        {
          values: g,
          isUpdate: !0,
          onUpdate: p,
          onClose: n,
          isLoading: l
        }
      ),
      "Update attribute",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  L(() => {
    h && o({
      message: h,
      variant: "success"
    });
  }, [h]);
  const j = F(() => Me.createCols(C, x), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - Metadata";
  }, []), /* @__PURE__ */ t.jsx(u, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
    /* @__PURE__ */ t.jsx(
      Te,
      {
        title: "Metadata",
        canCreate: !0,
        onCreate: T,
        createButtonName: "Add attribute"
      }
    ),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      le,
      {
        columns: j,
        data: i,
        loadingMessage: "",
        totalElements: i == null ? void 0 : i.length,
        loading: l,
        hideSettings: !0,
        onRowClick: (g) => {
          S(g.original);
        },
        onEdit: (g) => {
          m(g);
        }
      }
    ) })
  ] }) });
}, Ss = (e) => ({
  rowId: "id",
  loadingMessage: "Loading users...",
  addButtonTitle: "Add user",
  tableTitle: "Users",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (s, n) => _e(
    s,
    n,
    _t
  ),
  createFiltersPanel: (s, n) => ve(
    s,
    n,
    Wn
  ),
  createSortingMethod(s) {
    return we(s, { getSorting: Kn });
  },
  cols: [
    {
      header: "First name",
      accessorKey: "firstName",
      id: "firstName"
    },
    {
      header: "Last name",
      accessorKey: "lastName",
      id: "lastName"
    },
    {
      header: "Tenants",
      accessorFn: (s) => {
        var n;
        return ((n = s.tenants) == null ? void 0 : n.map((a) => {
          var r;
          return (r = a == null ? void 0 : a.object) == null ? void 0 : r.title;
        }).join(", ")) || "-";
      },
      id: "tenants"
    },
    {
      header: "Email",
      accessorKey: "email",
      id: "email",
      size: 220
    },
    {
      header: "",
      accessorKey: "id",
      enableHiding: !1,
      enableSorting: !1,
      enableResizing: !1,
      size: 40,
      meta: {
        columnType: "action"
      },
      cell: (s) => /* @__PURE__ */ t.jsx(je, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
        Ge,
        {
          iconName: "add",
          color: "default",
          size: "small",
          noExpand: !0,
          onClick: (n) => {
            n.stopPropagation(), e(s.row.original);
          }
        }
      ) }) })
    }
  ]
}), Cs = () => {
  const e = Q(), { openModal: s, closeModal: n } = M(ae), a = M(
    B
  ), [r, c] = E();
  L(() => {
    e(
      ee([
        {
          name: "Settings",
          path: `${a.path}`
        },
        {
          name: "Users",
          path: `${a.path}/users`
        }
      ])
    );
  }, [a.path]);
  const o = (i) => {
    s(
      () => /* @__PURE__ */ t.jsx(
        Ye,
        {
          user: i,
          typeEntity: Ke.USERS,
          onClose: () => {
            c(J()), n();
          }
        }
      ),
      "Add user to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ t.jsx(u, { container: !0, children: /* @__PURE__ */ t.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: Ss(o),
      allowDelete: !0,
      onRowClick: () => {
      },
      reloadId: r,
      variant: "no-header"
    }
  ) });
};
var U = /* @__PURE__ */ ((e) => (e.DATA_SOURCES = "data_sources", e.USERS = "users", e.METADATA = "metadata", e))(U || {});
const Rt = (e) => {
  const { pageNumber: s, pageSize: n, sortBy: a, query: r } = e, c = Se(a), o = `/datasource/admin/list?${r || ""}&size=${n || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, bs = (e) => {
  const s = `/datasource/admin/filter?${e}`;
  return b.get(s);
}, As = (e) => b.post("/datanodes", e), fs = (e, s) => b.post(`/datanodes/${e}`, s), kt = (e) => {
  const { pageNumber: s, pageSize: n, sortBy: a, query: r } = e, c = Se(a), o = `/datanodes/list?${r || ""}&size=${n || ""}&page=${s || ""}&sort=${c}`;
  return b.get(o);
}, Es = (e) => {
  const s = `/datanodes/filter?${e}`;
  return b.get(s);
}, Ns = () => Promise.resolve(["name", "nodeAddress", "registrarAddress", "description"]), ws = () => b.get("/datasource/admin/sorts"), vs = (e, s) => b.put(`/data-sources/${e}`, s), _s = (e) => b.post("/data-sources", e), Ls = (e) => b.get(`/data-sources/default/${e}`), Is = (e, s) => b.post(`/data-sources/default/${s}/${e}`), Os = (e) => b.get(`/data-sources/with-record-counts/${e}`), Ds = (e) => b.get(`/datasource/tenant/${e}`);
function Rs(e) {
  const [s, n] = E(null), [a, r] = E(w.INITIAL), [c, o] = E([]), [i, d] = E(w.INITIAL), p = async () => {
    d(w.IN_PROGRESS);
    try {
      const l = await Os(e);
      o(l), d(w.SUCCESS);
    } catch (l) {
      console.error(l), d(w.ERROR);
    }
  }, m = async () => {
    r(w.IN_PROGRESS);
    try {
      const l = await Ls(e);
      n(l), r(w.SUCCESS);
    } catch (l) {
      console.error(l), r(w.ERROR);
    }
  }, C = async (l) => {
    r(w.IN_PROGRESS);
    try {
      if (l) {
        const h = await Is(e, l);
        n(h);
      } else
        n(null);
      r(w.SUCCESS);
    } catch (h) {
      console.error(h), r(w.ERROR);
    }
  };
  return L(() => {
    m();
  }, [e]), L(() => {
    p();
  }, [e]), { dataSource: s, status: a, dataSources: c, listStatus: i, updateDataSource: C };
}
const ks = (e) => {
  const { status: s, dataSource: n, dataSources: a, listStatus: r, updateDataSource: c } = Rs(e.value || e.getValue());
  return /* @__PURE__ */ t.jsx(
    tn,
    {
      onClick: (o) => {
        o.stopPropagation();
      },
      width: 220,
      children: /* @__PURE__ */ t.jsx(
        gt,
        {
          value: n,
          fullWidth: !0,
          size: "small",
          onChange: (o, i) => {
            c(i == null ? void 0 : i.id);
          },
          placeholder: "Select default Data Source",
          options: a,
          getOptionLabel: function(o) {
            return o.name || "";
          },
          isOptionEqualToValue: (o, i) => o.id === i.id,
          loading: s === w.IN_PROGRESS || r === w.IN_PROGRESS,
          disableClearable: !0
        }
      )
    }
  );
}, Ms = {
  add: ft,
  delete: Et,
  update: Nt
}, Ps = {
  add: Ln,
  delete: In
}, $s = {
  add: On,
  delete: Dn
}, zs = (e, s, n) => [
  {
    header: "Name",
    accessorKey: "title"
  },
  {
    header: "Active",
    accessorKey: "active",
    size: 40,
    maxSize: 40,
    enableSorting: !1,
    meta: { align: "center", headerAlign: "center" },
    cell: (a) => /* @__PURE__ */ t.jsx(
      je,
      {
        text: a.value ? "Active" : "Not active",
        color: "primary",
        width: "auto",
        children: /* @__PURE__ */ t.jsx("div", { children: a.value ? /* @__PURE__ */ t.jsx(_, { iconName: "check", className: "icon-analysis" }) : /* @__PURE__ */ t.jsx(t.Fragment, { children: "-" }) })
      }
    )
  },
  {
    header: "Data sources",
    accessorKey: "data-sources",
    meta: { align: "center", headerAlign: "center" },
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ t.jsx(
      v,
      {
        onClick: (r) => {
          r.stopPropagation(), e(a.row.original.id, !!a.row.original.parent);
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "data sources"
      }
    )
  },
  {
    header: "Users",
    accessorKey: "participants",
    meta: { align: "center", headerAlign: "center" },
    size: 80,
    maxSize: 80,
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ t.jsx(
      v,
      {
        onClick: (r) => {
          r.stopPropagation(), s(
            a.row.original.id,
            !!a.row.original.parent
          );
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "users"
      }
    )
  },
  {
    header: "Metadata",
    accessorKey: "metadata",
    meta: { align: "center", headerAlign: "center" },
    enableSorting: !1,
    cell: (a) => /* @__PURE__ */ t.jsx(
      v,
      {
        onClick: (r) => {
          r.stopPropagation(), n(a.row.original.id, !!a.row.original.parent);
        },
        variant: "text",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "metadata"
      }
    )
  },
  {
    header: "Analysis Types",
    accessorFn: (a) => {
      var r, c;
      return ((c = (r = a.relations) == null ? void 0 : r.analysisTypes) == null ? void 0 : c.length) > 0 ? a.relations.analysisTypes.map((o) => o.name) : ["All analyses"];
    },
    cell: Ee,
    width: "25%",
    isCropped: !0,
    enableSorting: !1
  },
  {
    header: "Default source for counts (RC/DRC PC/DPC)",
    id: "rc-data-source",
    accessorKey: "id",
    enableSorting: !1,
    size: 240,
    minSize: 240,
    meta: { columnType: "action" },
    cell: ks
  },
  {
    header: "",
    accessorKey: "actions",
    isCropped: !0,
    enableSorting: !1,
    size: 40,
    maxSize: 40,
    meta: { columnType: "action", align: "center", headerAlign: "center" },
    cell: () => /* @__PURE__ */ t.jsx(xe, { onRemove: () => {
    } })
  }
], Le = V(
  (e) => {
    const { study: s, analysisTypes: n, onChange: a, isLogger: r, onChangeLogger: c } = e, [o] = E(s.analysisTypes), [i, d] = E(
      s.analysisTypes
    ), p = (h, x) => h.map((T) => ({ value: T.type, name: T.name })).filter((T) => !(i.includes(T.value) && T.value !== x)).sort(
      (T, S) => T.name.localeCompare(S.name, void 0, {
        sensitivity: "base"
      })
    ), m = () => {
      d([...i, ""]);
    }, C = (h) => {
      const x = [...i];
      x.splice(h, 1), d(x);
    }, l = (h, x) => {
      d((T) => {
        let S = [...T];
        return S.splice(
          h === "up" ? x - 1 : x + 1,
          0,
          S.splice(x, 1)[0]
        ), S;
      });
    };
    return L(() => {
      r ? c({
        updated: at(i),
        deleted: o.filter(
          (h) => !i.includes(h)
        )
      }) : a(at(i));
    }, [i]), /* @__PURE__ */ t.jsxs(u, { container: !0, mt: 1, children: [
      /* @__PURE__ */ t.jsx(u, { container: !0, spacing: 2, children: i.map((h, x) => /* @__PURE__ */ t.jsxs(
        u,
        {
          container: !0,
          item: !0,
          xs: 12,
          alignItems: "center",
          spacing: 1,
          children: [
            /* @__PURE__ */ t.jsx(u, { item: !0, children: /* @__PURE__ */ t.jsxs(he, { variant: "subtitle2", component: "span", children: [
              x + 1,
              "."
            ] }) }),
            /* @__PURE__ */ t.jsxs(u, { item: !0, children: [
              /* @__PURE__ */ t.jsx(
                v,
                {
                  onClick: () => {
                    l("up", x);
                  },
                  variant: "outlined",
                  sx: {
                    minWidth: 30,
                    height: 30,
                    borderColor: "borderColor.main",
                    p: 0,
                    mr: 0.5
                  },
                  disabled: x === 0,
                  children: /* @__PURE__ */ t.jsx(
                    _,
                    {
                      iconName: "chevron",
                      sx: { fontSize: 14, transform: "rotate(180deg)" }
                    }
                  )
                }
              ),
              /* @__PURE__ */ t.jsx(
                v,
                {
                  onClick: () => {
                    l("down", x);
                  },
                  variant: "outlined",
                  sx: {
                    minWidth: 30,
                    height: 30,
                    p: 0,
                    borderColor: "borderColor.main"
                  },
                  disabled: x === (i == null ? void 0 : i.length) - 1,
                  children: /* @__PURE__ */ t.jsx(_, { iconName: "chevron", sx: { fontSize: 14 } })
                }
              )
            ] }),
            /* @__PURE__ */ t.jsx(u, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              ne,
              {
                className: "analysisTypes",
                name: "analysisTypes",
                disablePortal: !0,
                id: "analysisTypes",
                options: p(n, h),
                value: h,
                placeholder: "Select analysis types...",
                onChange: (T) => {
                  const S = [...i];
                  S.splice(x, 1, T), d(S);
                },
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ t.jsx(u, { item: !0, children: /* @__PURE__ */ t.jsx(
              v,
              {
                onClick: () => {
                  C(x);
                },
                sx: { minWidth: 0, height: 30 },
                children: /* @__PURE__ */ t.jsx(
                  _,
                  {
                    iconName: "delete",
                    fontSize: "small",
                    color: "error",
                    sx: { fontSize: 16 }
                  }
                )
              }
            ) })
          ]
        },
        x + "analysis-type"
      )) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ t.jsx(
        v,
        {
          disabled: n.length === i.length,
          onClick: m,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "add" }),
          name: "add",
          children: "Add Analysis Type"
        }
      ) })
    ] });
  }
), Us = V((e) => {
  const { onClose: s, values: n, analysisTypes: a, onFinish: r, currentAnalysisTypes: c } = e, [o, i] = E(!1), { enqueueSnackbar: d } = z(), [p, m] = E({
    id: n == null ? void 0 : n.id,
    title: (n == null ? void 0 : n.title) || "",
    analysisTypes: c || []
  }), C = O(async () => {
    i(!0);
    try {
      await vt(n.id, p.analysisTypes), r({
        ...n,
        relations: {
          analysisTypes: a.filter(
            (h) => p.analysisTypes.includes(h.type)
          )
        }
      }), i(!1);
    } catch (h) {
      i(!1), d({
        message: "Something went wrong",
        variant: "error"
      }), console.error(h);
    }
  }, [p]), l = F(() => !p.title, [p]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        placeholder: "Enter title...",
        disabled: !0,
        value: p.title,
        onChange: (h) => {
          m((x) => ({ ...x, title: h.target.value }));
        },
        fullWidth: !0,
        required: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(nn, { severity: "info", children: "Unless explicitly specified below, all analysis types will be accessible without restrictions." }) }),
    /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Analysis Types" }),
      /* @__PURE__ */ t.jsx(
        Le,
        {
          study: {
            analysisTypes: p.analysisTypes
          },
          analysisTypes: a,
          onChange: (h) => {
            m((x) => ({
              ...x,
              analysisTypes: h
            }));
          }
        }
      ),
      /* @__PURE__ */ t.jsx(Ne, { sx: { mt: 2 } })
    ] }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          disabled: o || l,
          onClick: C,
          variant: "contained",
          color: "success",
          startIcon: o ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          children: n ? "Change" : "Create"
        }
      )
    ] }) })
  ] }) }) });
}), Fs = jn(u)`
  padding: 4px 4px 4px 8px;
  border-bottom: 1px solid
    ${({ theme: e }) => e.palette.borderColor.light};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme: e }) => e.palette.backgroundColor.main};
  }
  svg {
    font-size: 16px;
  }
`, Mt = (e) => {
  var a, r, c, o, i, d, p;
  const s = (e == null ? void 0 : e.roles) || ((a = e == null ? void 0 : e.object) == null ? void 0 : a.roles), n = se(
    (e == null ? void 0 : e.dataSteward) ?? (e == null ? void 0 : e.steward) ?? (e == null ? void 0 : e.owner) ?? ((r = e == null ? void 0 : e.object) == null ? void 0 : r.dataSteward) ?? ((c = e == null ? void 0 : e.object) == null ? void 0 : c.steward) ?? ((o = e == null ? void 0 : e.object) == null ? void 0 : o.owner) ?? s
  );
  return {
    steward: n,
    dataSteward: n,
    owner: !!((e == null ? void 0 : e.owner) ?? ((i = e == null ? void 0 : e.object) == null ? void 0 : i.owner) ?? (s == null ? void 0 : s.owner) ?? n),
    admin: de(
      (e == null ? void 0 : e.admin) ?? ((d = e == null ? void 0 : e.object) == null ? void 0 : d.admin) ?? s ?? (e == null ? void 0 : e.actions) ?? ((p = e == null ? void 0 : e.object) == null ? void 0 : p.actions)
    )
  };
}, Fe = (e) => {
  var s;
  return {
    steward: se(e == null ? void 0 : e.roles),
    dataSteward: se(e == null ? void 0 : e.roles),
    owner: !!(((s = e == null ? void 0 : e.roles) == null ? void 0 : s.owner) ?? se(e == null ? void 0 : e.roles)),
    admin: de(e == null ? void 0 : e.roles)
  };
}, qs = (e, s) => Object.values(Pt(e, s)).some(Boolean), Pt = (e, s) => {
  const n = Fe(e), a = Fe(s);
  return {
    steward: n.steward !== a.steward,
    dataSteward: n.dataSteward !== a.dataSteward,
    owner: n.owner !== a.owner,
    admin: n.admin !== a.admin
  };
}, Gs = (e, s) => {
  if (!(!e && !s))
    return {
      steward: !!(e != null && e.steward || s != null && s.steward),
      dataSteward: !!(e != null && e.dataSteward || s != null && s.dataSteward),
      owner: !!(e != null && e.owner || s != null && s.owner),
      admin: !!(e != null && e.admin || s != null && s.admin)
    };
}, Bs = (e) => Array.from(
  e.reduce((s, n) => {
    const a = n.object.id, r = s.get(a);
    return r ? (s.set(a, {
      ...r,
      roles: Gs(r.roles, n.roles)
    }), s) : (s.set(a, n), s);
  }, /* @__PURE__ */ new Map()).values()
), Ws = (e, s) => (e.object.title || "").localeCompare(
  s.object.title || "",
  void 0,
  { sensitivity: "base" }
) || e.object.id.localeCompare(s.object.id), Pe = (e) => [...e].sort(Ws), Ks = (e) => ({
  id: "",
  object: {
    id: e.id,
    title: e.firstName ? `${e.firstName} ${e.lastName}` : e.name,
    moduleIds: e.moduleIds
  },
  roles: Mt(e)
}), Vs = {
  list: [],
  original: [],
  initialTenantList: [],
  selectedTenantList: [],
  status: w.INITIAL,
  error: null
}, Hs = (e, s) => Be(e, (n) => {
  switch (s.type) {
    case "GET_LIST":
      n.status = w.IN_PROGRESS;
      break;
    case "GET_LIST_SUCCESS":
      n.original = s.payload.original, n.list = s.payload.list, n.initialTenantList = s.payload.tenantList, n.selectedTenantList = s.payload.tenantList, n.status = w.SUCCESS;
      break;
    case "CHANGE_SELECTED_LIST":
      n.selectedTenantList = s.payload;
      break;
    case "GET_LIST_FAILED":
      n.status = w.ERROR, n.error = s.payload;
  }
}), Ys = (e, s, n, a) => {
  const [r, c] = qe(
    Hs,
    Vs
  ), o = async () => {
    c({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const m = s ? await n(e) : await n({
        pageSize: 1e4
      }), C = await a(e), l = Bs(
        C.map((x) => ({
          ...x,
          roles: Mt(x)
        }))
      ), h = m.content || m;
      c({
        type: "GET_LIST_SUCCESS",
        payload: {
          original: h,
          list: Pe(
            h.map((x) => l.find((S) => S.object.id === x.id) || Ks(x))
          ),
          tenantList: Pe(l)
        }
      });
    } catch (m) {
      c({
        type: "GET_LIST_FAILED",
        payload: m
      });
    }
  }, i = O(
    (m, C) => {
      const l = r.initialTenantList.find((x) => x.object.id === m) || r.list.find((x) => x.object.id === m);
      if (!l)
        return;
      const h = C ? r.selectedTenantList.filter((x) => x.object.id !== m) : r.selectedTenantList.some((x) => x.object.id === m) ? r.selectedTenantList : [...r.selectedTenantList, l];
      c({
        type: "CHANGE_SELECTED_LIST",
        payload: Pe(h)
      });
    },
    [r]
  ), d = O(
    (m, C, l) => {
      const h = r.selectedTenantList.map((x) => {
        if (x.object.id !== m)
          return x;
        const S = {
          ...Fe(x),
          [C]: l
        };
        return C === "steward" && (S.owner = l, S.dataSteward = l), C === "dataSteward" && (S.steward = l, S.owner = l), C === "owner" && (S.steward = l, S.dataSteward = l), {
          ...x,
          roles: S
        };
      });
      c({
        type: "CHANGE_SELECTED_LIST",
        payload: h
      });
    },
    [r.selectedTenantList]
  ), p = O(() => {
    const m = new Map(
      r.initialTenantList.map((T) => [T.object.id, T])
    ), C = new Set(
      r.selectedTenantList.map((T) => T.object.id)
    ), l = r.selectedTenantList.filter(
      (T) => !m.has(T.object.id)
    ), h = r.initialTenantList.filter(
      (T) => !C.has(T.object.id)
    ), x = r.selectedTenantList.reduce(
      (T, S) => {
        const j = m.get(S.object.id);
        return j && qs(j, S) && T.push({
          ...S,
          roleChanges: Pt(j, S)
        }), T;
      },
      []
    );
    return { added: l, deleted: h, updated: x };
  }, [r]);
  return L(() => {
    o();
  }, []), {
    ...r,
    changeSelectedList: i,
    changeRole: d,
    prepareListForSave: p
  };
}, Js = {
  [U.DATA_SOURCES]: {
    name: U.DATA_SOURCES,
    titleAddedSection: "Added data sources",
    titleDropdownSection: "Add new data source",
    placeholder: "Select data source..."
  },
  [U.METADATA]: {
    name: U.METADATA,
    titleAddedSection: "Added attributes",
    titleDropdownSection: "Add new attribute",
    placeholder: "Select attribute..."
  },
  [U.USERS]: {
    name: U.USERS,
    titleAddedSection: "Added users",
    titleDropdownSection: "Add new users",
    placeholder: "Select users..."
  }
}, Xs = (e) => {
  const { tenantId: s, onChange: n, hasParent: a, getList: r, getListByTenant: c, type: o } = e, { titleAddedSection: i, titleDropdownSection: d, placeholder: p, name: m } = Js[o], {
    list: C,
    selectedTenantList: l,
    status: h,
    changeSelectedList: x,
    changeRole: T,
    prepareListForSave: S
  } = Ys(s, a, r, c), j = o === U.USERS, g = ce.useMemo(() => {
    const N = l.map((W) => W.object.id);
    return C.filter((W) => !N.includes(W.object.id));
  }, [C, l]);
  if (L(() => {
    n(S());
  }, [l]), [w.INITIAL, w.IN_PROGRESS].includes(h))
    return /* @__PURE__ */ t.jsx(yt, { children: /* @__PURE__ */ t.jsx(Z, { size: 32 }) });
  const A = /* @__PURE__ */ t.jsxs(u, { container: !0, mt: j ? 0 : 2, children: [
    j && l.length > 0 && /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, container: !0, px: 1, pb: 0.75, alignItems: "center", children: [
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 7, children: /* @__PURE__ */ t.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "User"
        }
      ) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "Steward"
        }
      ) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(
        he,
        {
          variant: "caption",
          color: "text.secondary",
          fontWeight: 700,
          children: "Admin"
        }
      ) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 1 })
    ] }),
    l.length > 0 ? l.map((N) => /* @__PURE__ */ t.jsxs(
      Fs,
      {
        item: !0,
        xs: 12,
        container: !0,
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ t.jsx(u, { item: !0, xs: j ? 7 : 11, children: N.object.title }),
          j && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            /* @__PURE__ */ t.jsx(u, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(
              $e,
              {
                checked: se(N.roles),
                onChange: (R) => T(
                  N.object.id,
                  "steward",
                  R.target.checked
                ),
                size: "small"
              }
            ) }),
            /* @__PURE__ */ t.jsx(u, { item: !0, xs: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(
              $e,
              {
                checked: de(N.roles),
                onChange: (R) => T(N.object.id, "admin", R.target.checked),
                size: "small"
              }
            ) })
          ] }),
          /* @__PURE__ */ t.jsx(u, { item: !0, xs: j ? 1 : void 0, textAlign: "center", children: /* @__PURE__ */ t.jsx(
            v,
            {
              sx: { minWidth: 20 },
              color: "error",
              onClick: () => x(N.object.id, !0),
              children: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate", fontSize: "small" })
            }
          ) })
        ]
      },
      N.object.id
    )) : /* @__PURE__ */ t.jsx("div", { children: "-" })
  ] });
  return /* @__PURE__ */ t.jsxs(u, { container: !0, p: 2, spacing: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: j ? A : /* @__PURE__ */ t.jsx(I, { name: "existingEntities", textLabel: i, children: A }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: m, textLabel: d, children: /* @__PURE__ */ t.jsx(
      gt,
      {
        className: "",
        name: m,
        id: m,
        options: g,
        value: { object: { title: "" } },
        placeholder: p,
        onChange: (N, R) => R && x(R.object.id, !1),
        fullWidth: !0,
        getOptionLabel: (N) => N.object.title,
        isOptionEqualToValue: (N, R) => N.id === (R == null ? void 0 : R.id),
        disableClearable: !0
      }
    ) }) }) })
  ] });
}, be = (e) => {
  var l, h, x;
  const {
    onClose: s,
    onChange: n,
    tenantId: a,
    hasParent: r,
    getList: c,
    getListByTenant: o,
    type: i
  } = e, { enqueueSnackbar: d } = z(), [p, m] = E(), C = O(async () => {
    const T = await n(p, a);
    if (T.error) {
      d(T.message, { variant: "error" });
      return;
    }
    d(T.message, { variant: "success" }), s();
  }, [p]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Xs,
      {
        tenantId: a,
        hasParent: r,
        onChange: (T) => {
          m(T);
        },
        getList: c,
        getListByTenant: o,
        type: i
      }
    ) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          onClick: C,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          disabled: !((l = p == null ? void 0 : p.added) != null && l.length) && !((h = p == null ? void 0 : p.deleted) != null && h.length) && !((x = p == null ? void 0 : p.updated) != null && x.length),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}, Zs = ({ analysisTypes: e }) => {
  const s = Q(), { openModal: n, closeModal: a } = M(ae), { enqueueSnackbar: r } = z(), { path: c } = M(
    B
  ), o = Ve((g) => g.user), { tenants: i, setActiveTenant: d, updateTenant: p } = He(
    o.data
  );
  L(() => {
    s(
      ee([
        {
          name: "Settings",
          path: `${c}`
        },
        {
          name: "Tenants",
          path: `${c}/tenants`
        }
      ])
    );
  }, [c]);
  const m = Ce("Users", Ms), C = Ce(
    "Data sources",
    Ps
  ), l = Ce("Metadata", $s), h = (g, A) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        Us,
        {
          values: g,
          onClose: a,
          analysisTypes: e,
          currentAnalysisTypes: A,
          currentUser: o,
          onFinish: (N) => {
            p(N), r({
              message: "Tenant Analysis Types Changed",
              variant: "success"
            }), a();
          }
        }
      ),
      "Change Tenant Analysis Types",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, x = (g, A) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        be,
        {
          onClose: a,
          tenantId: g,
          hasParent: A,
          onChange: C,
          getList: Rt,
          getListByTenant: Ds,
          type: U.DATA_SOURCES
        }
      ),
      "Data sources",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, T = (g, A) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        be,
        {
          onClose: a,
          tenantId: g,
          hasParent: A,
          onChange: m,
          getList: _t,
          getListByTenant: Lt,
          type: U.USERS
        }
      ),
      "Users",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, S = (g, A) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        be,
        {
          onClose: a,
          tenantId: g,
          hasParent: A,
          onChange: l,
          getList: zn,
          getListByTenant: Gn,
          type: U.METADATA
        }
      ),
      "Metadata",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, j = F(() => zs(x, T, S), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - Tenants";
  }, []), /* @__PURE__ */ t.jsx(
    u,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        le,
        {
          columns: j,
          data: i,
          loadingMessage: "Loading tenants...",
          hideSettings: !0,
          totalElements: i == null ? void 0 : i.length,
          onEdit: async (g) => {
            await d(g.value), location.reload();
          },
          onRowClick: async (g) => {
            const A = await wt(
              g.original.id
            );
            h(g.original, A);
          }
        }
      ) })
    }
  );
}, Qs = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Data sources",
    path: `${e}/data-sources`
  }
], ea = (e) => ({
  rowId: "id",
  loadingMessage: "Loading data sources...",
  addButtonTitle: "Add data source",
  tableTitle: "Data sources",
  createCrudMethod: (s, n) => _e(
    s,
    n,
    Rt,
    () => Promise.resolve()
  ),
  createFiltersPanel: (s, n) => ve(
    s,
    n,
    bs
  ),
  createSortingMethod: (s) => we(s, {
    getSorting: ws
  }),
  cols: [
    Ae({
      cell: ({
        row: s
      }) => {
        const { original: n } = s;
        return /* @__PURE__ */ t.jsx(t.Fragment, { children: n ? /* @__PURE__ */ t.jsx(Wt, { dataSource: n }) : "" });
      }
    }),
    {
      header: "Organization",
      id: "organization",
      accessorFn: (s) => {
        var n;
        return ((n = s.dataNode) == null ? void 0 : n.name) || "";
      },
      enableSorting: !1,
      size: 160
    },
    {
      header: "Model type",
      accessorKey: "modelType",
      size: 100,
      minSize: 80
    },
    // {
    //   header: 'Version',
    //   accessor: 'cdmVersion',
    //   Cell: ({ value: cdmVersion }) => (
    //     <span>{parseCdmVersion(cdmVersion)}</span>
    //   ),
    // },
    {
      header: "Access type",
      accessorKey: "accessType",
      enableResizing: !1,
      size: 120,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({
        renderValue: s
      }) => {
        const n = rt();
        return s() ? /* @__PURE__ */ t.jsx(
          st,
          {
            light: !0,
            color: hn(s(), n),
            text: s(),
            align: "center"
          }
        ) : "";
      }
    },
    {
      id: "executionPolicy",
      header: "Execution policy",
      accessorKey: "executionPolicy",
      enableResizing: !1,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: ({
        renderValue: s
      }) => {
        const n = rt();
        return s() ? /* @__PURE__ */ t.jsx(
          st,
          {
            light: !0,
            text: s(),
            color: yn(s(), n),
            align: "center",
            minWidth: 90
          }
        ) : "";
      }
    },
    {
      header: "",
      accessorKey: "id",
      enableSorting: !1,
      maxWidth: 40,
      meta: {
        columnType: "action"
      },
      cell: (s) => /* @__PURE__ */ t.jsx(je, { text: "Add to tenant", color: "primary", width: "auto", children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
        Ge,
        {
          iconName: "add",
          color: "default",
          size: "small",
          noExpand: !0,
          onClick: (n) => {
            n.stopPropagation(), e(s.row.original);
          }
        }
      ) }) })
    }
  ]
}), ta = [
  {
    name: "Unrestricted",
    value: ze.PUBLIC
  },
  {
    name: "Restricted",
    value: ze.RESTRICTED
  }
], lt = V((e) => {
  var S;
  const { onClose: s, values: n, createMethod: a, updateMethod: r, isUpdate: c, afterCreate: o } = e, [i, d] = E({
    dataNodeId: ((S = n == null ? void 0 : n.dataNode) == null ? void 0 : S.id) || "",
    name: (n == null ? void 0 : n.name) || "",
    description: (n == null ? void 0 : n.description) || "",
    accessType: (n == null ? void 0 : n.accessType) || ze.PUBLIC,
    cdmVersion: (n == null ? void 0 : n.cdmVersion) || "",
    modelType: (n == null ? void 0 : n.modelType) || Tn.CDM,
    values: [],
    tenants: []
  }), [p, m] = E(!1), [C, l] = E([]), [h, x] = E([]);
  L(() => {
    m(!0), Ot().then((j) => {
      x(
        j.content.map((g) => ({ name: g.name, value: g.code }))
      );
    }), kt({}).then((j) => {
      l(
        j.content.map((g) => ({
          name: g.name,
          value: g.id
        }))
      ), m(!1);
    });
  }, []);
  const T = O(async () => {
    c ? await r(n.id, i) : await a(i), o == null || o();
  }, [i]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
    !p && C.length > 0 && /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "data-nodes", textLabel: "Data nodes", children: /* @__PURE__ */ t.jsx(
      ne,
      {
        name: "data-nodes",
        id: "data-nodes",
        options: C,
        value: i.dataNodeId,
        onChange: (j) => {
          d({
            ...i,
            dataNodeId: j
          });
        },
        placeholder: "Select data node...",
        className: "",
        disablePortal: !0,
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Name", children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        placeholder: "Enter name",
        value: i.name,
        onChange: (j) => {
          d({
            ...i,
            name: j.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "description", textLabel: "Description", children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        placeholder: "Enter description",
        value: i.description,
        onChange: (j) => {
          d({
            ...i,
            description: j.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(I, { name: "access-type", textLabel: "Access type", required: !0, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        className: "",
        name: "access-type",
        disablePortal: !0,
        id: "access-type",
        options: ta,
        value: i.accessType,
        placeholder: "Select type...",
        onChange: (j) => {
          d({ ...i, accessType: j });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(I, { name: "ex", textLabel: "Model type", required: !0, children: /* @__PURE__ */ t.jsx(
      ne,
      {
        className: "",
        name: "ex",
        disablePortal: !0,
        id: "ex",
        options: h,
        value: i.modelType,
        placeholder: "Select type...",
        onChange: (j) => {
          d({ ...i, modelType: j });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          onClick: T,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), na = () => {
  const e = Q(), { openModal: s, closeModal: n } = M(ae), a = M(
    B
  ), { enqueueSnackbar: r } = z(), [c, o] = E();
  L(() => {
    e(ee(Qs(a.path)));
  }, [a.path]);
  const i = () => {
    s(
      () => /* @__PURE__ */ t.jsx(
        lt,
        {
          createMethod: _s,
          afterCreate: () => {
            r({
              message: "Create data source successfully",
              variant: "success"
            }), o(J()), n();
          },
          onClose: n
        }
      ),
      "Add data source",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, d = (m) => {
    s(
      () => /* @__PURE__ */ t.jsx(
        lt,
        {
          isUpdate: !0,
          values: m.original,
          updateMethod: vs,
          afterCreate: () => {
            r({
              message: "Update data source successfully",
              variant: "success"
            }), o(J()), n();
          },
          onClose: n
        }
      ),
      "Update data source",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, p = (m) => {
    s(
      () => /* @__PURE__ */ t.jsx(
        Ye,
        {
          user: m,
          typeEntity: Ke.USERS,
          onClose: () => {
            o(J()), n();
          }
        }
      ),
      "Add user to tenant",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ t.jsx(u, { container: !0, minHeight: "100%", children: /* @__PURE__ */ t.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: ea(p),
      onRowClick: d,
      reloadId: c,
      onCreate: i,
      variant: "no-header"
    }
  ) });
}, sa = (e) => {
  const s = [
    {
      title: "Tenants",
      value: "",
      end: !0
    },
    {
      title: "User Groups",
      value: "groups"
    },
    // {
    //   title: 'Data sources',
    //   value: `data-sources`,
    // },
    {
      title: "Users",
      value: "users"
    },
    {
      title: "Metadata",
      value: "metadata"
    },
    {
      title: "Model Types",
      value: "model-types"
    },
    {
      title: "Study Types",
      value: "study-types"
    },
    {
      title: "Data nodes",
      value: "data-nodes"
    },
    {
      title: "Audit Logs",
      value: "audit-logs"
    }
  ];
  return e && s.push({
    title: "Analysis settings",
    value: "analysis-settings"
  }), s;
}, aa = (e) => ({
  rowId: "id",
  loadingMessage: "Loading data nodes...",
  addButtonTitle: "Add data node",
  tableTitle: "Data nodes",
  createCrudMethod: (s, n) => _e(
    s,
    n,
    kt
  ),
  createFiltersPanel: (s, n) => ve(
    s,
    n,
    Es
  ),
  createSortingMethod(s) {
    return we(s, {
      getSorting: Ns
    });
  },
  cols: [
    Ae({ size: 300 }),
    {
      header: "Node address",
      accessorKey: "nodeAddress",
      id: "nodeAddress"
    },
    {
      header: "Register address",
      accessorKey: "registrarAddress",
      id: "registrarAddress"
    },
    {
      header: "Published",
      accessorKey: "published",
      enableSorting: !1,
      size: 90,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: (s) => s.getValue() ? /* @__PURE__ */ t.jsx(_, { iconName: "check", className: "icon-analysis" }) : "-"
    },
    {
      header: "Virtual",
      accessorKey: "virtual",
      enableSorting: !1,
      size: 90,
      meta: {
        align: "center",
        headerAlign: "center"
      },
      cell: (s) => s.renderValue() ? /* @__PURE__ */ t.jsx(_, { iconName: "check", className: "icon-analysis" }) : "-"
    },
    {
      header: "Description",
      accessorKey: "description",
      size: 220
    }
  ]
}), ra = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Data nodes",
    path: `${e}/data-nodes`
  }
], dt = V((e) => {
  const {
    onClose: s,
    values: n,
    createMethod: a,
    updateMethod: r,
    isUpdate: c,
    afterCreate: o,
    disableForm: i
  } = e, [d, p] = E(!1), [m, C] = E(
    n || {
      name: "",
      description: ""
    }
  ), l = O(async () => {
    p(!0), c ? (await r(n.id, m), p(!1)) : (await a(m), p(!1)), o == null || o();
  }, [m]);
  return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        placeholder: "Enter name",
        disabled: i,
        value: m.name,
        onChange: (h) => {
          C({
            ...m,
            name: h.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "description", textLabel: "Description", children: /* @__PURE__ */ t.jsx(
      G,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        placeholder: "Enter description",
        disabled: i,
        value: m.description,
        onChange: (h) => {
          C({
            ...m,
            description: h.target.value
          });
        },
        fullWidth: !0
      }
    ) }) }),
    !i && /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
      /* @__PURE__ */ t.jsx(
        v,
        {
          variant: "outlined",
          onClick: s,
          disabled: d,
          startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        v,
        {
          onClick: l,
          variant: "contained",
          disabled: d || xt(m.name),
          color: "success",
          startIcon: d ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), oa = () => {
  const e = Q(), { openModal: s, closeModal: n } = M(ae), a = M(
    B
  ), { enqueueSnackbar: r } = z(), [c, o] = E();
  L(() => {
    e(ee(ra(a.path)));
  }, [a.path]);
  const i = () => {
    s(
      () => /* @__PURE__ */ t.jsx(
        dt,
        {
          createMethod: As,
          afterCreate: () => {
            r({
              message: "Create data node successfully",
              variant: "success"
            }), o(J()), n();
          },
          onClose: n
        }
      ),
      "Add data node",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  }, d = (p) => {
    s(
      () => /* @__PURE__ */ t.jsx(
        dt,
        {
          isUpdate: !0,
          values: p.original,
          updateMethod: fs,
          disableForm: !0,
          afterCreate: () => {
            r({
              message: "Update data node successfully",
              variant: "success"
            }), o(J()), n();
          },
          onClose: n
        }
      ),
      "Data node details",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ t.jsx(u, { container: !0, children: /* @__PURE__ */ t.jsx(
    fe,
    {
      moduleConfig: a,
      listConfig: aa(),
      allowDelete: !0,
      onRowClick: d,
      reloadId: c,
      onCreate: i,
      uniqName: "data-nodes"
    }
  ) });
}, ut = {
  entityBreadcrumb: (e) => [
    {
      name: "Settings",
      path: `${e}`
    },
    {
      name: "Analysis settings",
      path: `${e}/analysis-settings`
    }
  ],
  filterMetadata: "&filter.metadata.subject=DATA_SOURCE&filter.metadata.subject=CONCEPT_SET&filter.metadata.subject=COHORT",
  columns: [
    Ae(),
    {
      header: "Active",
      accessorKey: "active",
      enableSorting: !1,
      size: 20,
      maxSize: 30,
      cell: ({ getValue: e, ...s }) => /* @__PURE__ */ t.jsx(me, { value: e(), ...s }),
      meta: {
        headerAlign: "center",
        align: "center"
      }
    }
  ]
}, ia = (e) => {
  const { list: s, listStatus: n } = e, a = Q(), { path: r, getHealthCheck: c } = M(
    B
  ), [o, i] = E(w.INITIAL), d = F(
    () => [...s || []].sort(
      (C, l) => (C.name || "").localeCompare(l.name || "", void 0, {
        sensitivity: "base"
      })
    ),
    [s]
  ), p = async (C) => {
    const l = {};
    d == null || d.forEach((h) => {
      h.id === C.row.id ? l[h.id] = C.value : l[h.id] = h.active;
    });
    try {
      await us(l), i(w.SUCCESS);
    } catch {
      i(w.ERROR);
    }
  }, m = async () => {
    i(w.IN_PROGRESS);
    try {
      await ps({}), c(), i(w.INITIAL);
    } catch {
    }
  };
  return L(() => {
    a(ee(ut.entityBreadcrumb(r)));
  }, [r]), L(() => {
    document.title = "Prometheus - Analysis Settings";
  }, []), /* @__PURE__ */ t.jsx(
    u,
    {
      container: !0,
      px: 6,
      pb: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(
          Te,
          {
            title: "Analysis modules",
            customButtons: /* @__PURE__ */ t.jsx(
              v,
              {
                onClick: m,
                variant: "contained",
                color: "info",
                disabled: o === w.IN_PROGRESS,
                startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "reload" }),
                sx: { py: 0, fontSize: 14, px: 2 },
                children: "Restart modules"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          le,
          {
            columns: ut.columns,
            data: d,
            loadingMessage: "",
            loading: n === w.IN_PROGRESS,
            totalElements: d.length,
            hidePagination: !0,
            pageSize: d.length,
            hideSettings: !0,
            onEdit: p
          }
        ) })
      ] })
    }
  );
}, ca = (e) => {
  const { children: s, tabs: n } = e;
  return /* @__PURE__ */ t.jsxs(Kt, { children: [
    /* @__PURE__ */ t.jsxs(Vt, { children: [
      /* @__PURE__ */ t.jsx(Ht, { title: "Settings", iconName: "admin" }),
      /* @__PURE__ */ t.jsx(Yt, { tabs: n, withRouting: !0 })
    ] }),
    /* @__PURE__ */ t.jsx(Jt, { children: s })
  ] });
}, la = (e) => [
  {
    name: "Settings",
    path: `${e}`
  },
  {
    name: "Study Types",
    path: `${e}/study-types`
  }
], da = (e, s) => [
  {
    header: "Name",
    accessorKey: "name",
    size: 100
  },
  {
    header: "Analysis Types",
    id: "analysisTypes",
    accessorFn: (n) => {
      var a;
      return (a = n.analysisTypes) == null ? void 0 : a.map(
        (r) => {
          var c;
          return (c = e == null ? void 0 : e.find((o) => o.type === r)) == null ? void 0 : c.name;
        }
      );
    },
    cell: Ee,
    enableSorting: !1
  },
  {
    header: "Consent",
    accessorKey: "consent",
    enableSorting: !1,
    enableResizing: !1,
    meta: { align: "center", headerAlign: "center" },
    size: 40,
    maxSize: 40,
    cell: ({ getValue: n }) => /* @__PURE__ */ t.jsx(
      je,
      {
        text: n() ? "Active" : "Not active",
        color: "primary",
        width: "auto",
        children: /* @__PURE__ */ t.jsx("div", { children: n() ? /* @__PURE__ */ t.jsx(_, { iconName: "check", className: "icon-analysis" }) : /* @__PURE__ */ t.jsx(t.Fragment, { children: "-" }) })
      }
    )
  },
  {
    header: "",
    accessorKey: "id",
    id: "item-id",
    enableSorting: !1,
    enableResizing: !1,
    size: 40,
    maxSize: 40,
    meta: {
      columnType: "action"
    },
    cell: (n) => /* @__PURE__ */ t.jsx(
      xe,
      {
        entityType: n.row.original.name,
        withConfirmation: !0,
        onRemove: () => s(n.row.original.id)
      }
    )
  }
], pt = V(
  (e) => {
    const { onClose: s, values: n, analysisTypes: a, onFinish: r } = e, [c, o] = E(!1), { enqueueSnackbar: i } = z(), [d, p] = E({
      id: n == null ? void 0 : n.id,
      name: (n == null ? void 0 : n.name) || "",
      analysisTypes: (n == null ? void 0 : n.analysisTypes) || [],
      requireUserConsent: (n == null ? void 0 : n.requireUserConsent) || !1,
      requireUserConsentMessage: (n == null ? void 0 : n.requireUserConsentMessage) || ""
    }), m = O(async () => {
      o(!0);
      try {
        const l = n != null && n.id ? await Qn(n.id, d) : await Zn(d);
        r(l), o(!1);
      } catch (l) {
        o(!1), i({
          message: "Something went wrong",
          variant: "error"
        }), console.error(l);
      }
    }, [d]), C = F(() => !d.name || d.analysisTypes.length === 0, [d]);
    return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ t.jsx(
        G,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          placeholder: "Enter name",
          value: d.name,
          onChange: (l) => {
            p((h) => ({ ...h, name: l.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ t.jsx(
          Le,
          {
            study: d,
            analysisTypes: a,
            onChange: (l) => {
              p((h) => ({
                ...h,
                analysisTypes: l
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs("label", { children: [
        /* @__PURE__ */ t.jsx(
          $e,
          {
            name: "createNew",
            onChange: () => {
              p((l) => ({
                ...l,
                requireUserConsent: !l.requireUserConsent
              }));
            },
            checked: d.requireUserConsent,
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ t.jsx(
          he,
          {
            variant: "subtitle2",
            component: "span",
            lineHeight: "26px",
            children: "Require user consent"
          }
        )
      ] }) }),
      /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(
          sn,
          {
            id: "message",
            name: "message",
            value: d.requireUserConsentMessage,
            onChange: (l) => {
              p((h) => ({
                ...h,
                requireUserConsentMessage: l
              }));
            },
            maxRows: 10,
            minRows: 5,
            disableHorizontalResize: !0,
            placeholder: "Enter consent form"
          }
        ),
        /* @__PURE__ */ t.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
        /* @__PURE__ */ t.jsx(
          v,
          {
            variant: "outlined",
            onClick: s,
            startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ t.jsx(
          v,
          {
            disabled: c || C,
            onClick: m,
            variant: "contained",
            color: "success",
            startIcon: c ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
            name: "save",
            children: n ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), ua = (e) => {
  const { analysisTypes: s } = e, n = Q(), { openModal: a, closeModal: r } = M(ae), [c, o] = E([]), [i, d] = E([]), { path: p } = M(
    B
  ), { enqueueSnackbar: m } = z();
  L(() => {
    Vn().then((T) => {
      o(gn(T.content)), d(T.actions);
    });
  }, []), L(() => {
    n(ee(la(p)));
  }, [p]);
  const C = (T) => {
    a(
      () => /* @__PURE__ */ t.jsx(
        pt,
        {
          values: T,
          analysisTypes: s,
          onFinish: (S) => {
            const j = [...c], g = j.findIndex((A) => A.id === S.id);
            g !== -1 ? j.splice(g, 1, S) : j.unshift(S), o(j), m({
              message: "Study type created",
              variant: "success"
            }), r();
          },
          onClose: r
        }
      ),
      "Create Study Type",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: r
      }
    );
  }, l = O(
    async (T) => {
      const S = [...c];
      try {
        await es(T);
        const j = S.findIndex((g) => g.id === T);
        S.splice(j, 1), o(S), m({
          message: "Study type deleted",
          variant: "success"
        });
      } catch (j) {
        console.error(j);
      }
    },
    [c]
  ), h = O(
    async (T) => {
      try {
        const S = await Yn(T), j = await Jn(T), g = {
          ...S,
          requireUserConsent: j == null ? void 0 : j.required,
          requireUserConsentMessage: j == null ? void 0 : j.text
        };
        a(
          () => /* @__PURE__ */ t.jsx(
            pt,
            {
              values: g,
              analysisTypes: s,
              onFinish: (A) => {
                const N = [...c], R = N.findIndex(
                  (W) => W.id === A.id
                );
                R !== -1 ? N.splice(R, 1, A) : N.unshift(A), o(N), m({
                  message: g ? "Study type changed" : "Study type created",
                  variant: "success"
                }), r();
              },
              onClose: r
            }
          ),
          g ? "Change Study Type" : "Create Study Type",
          {
            closeOnClickOutside: !0,
            width: "700px",
            onClose: r
          }
        );
      } catch (S) {
        console.error(S);
      }
    },
    [s, c]
  ), x = F(() => da(s, l), [c]);
  return L(() => {
    document.title = "Prometheus - Study Types";
  }, []), /* @__PURE__ */ t.jsx(u, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
    /* @__PURE__ */ t.jsx(
      Te,
      {
        title: "Study Types",
        canCreate: !0,
        onCreate: () => C(),
        createButtonName: "Create Study Type"
      }
    ),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      le,
      {
        columns: x,
        data: c,
        loadingMessage: "",
        totalElements: c.length,
        onRowClick: async (T) => {
          await h(T.original.id);
        },
        hideSettings: !0
      }
    ) })
  ] }) });
}, pa = ({ analysisTypes: e }) => /* @__PURE__ */ t.jsx(ua, { analysisTypes: e }), ma = (e, s) => [
  {
    header: "Title",
    accessorKey: "title",
    size: 180
  },
  {
    header: "Tenant",
    accessorKey: "parent.name",
    enableSorting: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    header: "Users",
    accessorKey: "participants",
    meta: {
      align: "center",
      headerAlign: "center"
    },
    size: 120,
    maxSize: 120,
    cell: (n) => /* @__PURE__ */ t.jsx(
      v,
      {
        onClick: (a) => {
          a.stopPropagation(), e(
            n.row.original.id,
            !!n.row.original.parent
          );
        },
        variant: "text",
        size: "small",
        sx: { textDecoration: "underline" },
        className: "study",
        children: "users"
      }
    )
  },
  {
    header: "Analysis Types",
    accessorFn: (n) => {
      var a, r;
      return ((r = (a = n.relations) == null ? void 0 : a.analysisTypes) == null ? void 0 : r.length) > 0 ? n.relations.analysisTypes.map((c) => c.name) : ["-"];
    },
    cell: Ee,
    size: 300,
    enableSorting: !1
  },
  {
    header: "",
    accessorKey: "id",
    isCropped: !0,
    enableSorting: !1,
    maxSize: 100,
    meta: { columnType: "action" },
    cell: (n) => /* @__PURE__ */ t.jsx(
      xe,
      {
        entityType: n.row.original.name,
        withConfirmation: !0,
        onRemove: () => s(n.row.original.id)
      }
    )
  }
], ha = {
  add: ft,
  delete: Et,
  update: Nt
}, mt = (e, s, n = []) => {
  var r, c, o;
  const a = (o = (c = (r = e.find((i) => i.value === s)) == null ? void 0 : r.relations) == null ? void 0 : c.analysisTypes) == null ? void 0 : o.map((i) => i.type);
  return n.filter(
    (i) => !a.includes(i)
  );
}, ya = V(
  (e) => {
    var S, j;
    const {
      onClose: s,
      values: n,
      analysisTypes: a,
      onFinish: r,
      currentAnalysisTypes: c,
      tenants: o
    } = e, [i, d] = E(!1), { enqueueSnackbar: p } = z(), [m, C] = E({
      id: n == null ? void 0 : n.id,
      title: (n == null ? void 0 : n.title) || "",
      parent: (n == null ? void 0 : n.parent.id) || ((S = o[0]) == null ? void 0 : S.value),
      analysisTypes: mt(
        o,
        (n == null ? void 0 : n.parent.id) || ((j = o[0]) == null ? void 0 : j.value),
        c
      ) || []
    }), l = O(async () => {
      d(!0);
      try {
        const g = n != null && n.id ? await Pn(n.id, {
          id: m.id,
          title: m.title
        }) : await Mn(
          {
            title: m.title
          },
          m.parent
        );
        await vt(g.id, m.analysisTypes), r({
          ...g,
          relations: {
            analysisTypes: a.filter(
              (A) => m.analysisTypes.includes(A.type)
            )
          }
        }), d(!1);
      } catch (g) {
        d(!1), p({
          message: "Something went wrong",
          variant: "error"
        }), console.error(g);
      }
    }, [m, o]), h = F(() => {
      var A;
      const g = (A = n == null ? void 0 : n.relations) == null ? void 0 : A.analysisTypes.map(
        (N) => N.type
      );
      return (n == null ? void 0 : n.title) === m.title && g.length === m.analysisTypes.length && xn(g, m.analysisTypes).length === 0;
    }, [n, m]), x = (g) => {
      var N, R, W;
      const A = ((W = (R = (N = o.find((re) => re.value === g)) == null ? void 0 : N.relations) == null ? void 0 : R.analysisTypes) == null ? void 0 : W.map((re) => re.type)) || [];
      return a.length === A.length || A.length === 0 ? [] : a.filter((re) => !A.includes(re.type));
    };
    L(() => {
      C((g) => ({
        ...g,
        analysisTypes: mt(
          o,
          m.parent,
          m.analysisTypes
        )
      }));
    }, [m.parent]);
    const T = F(() => !m.title || !m.parent, [m]);
    return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ t.jsx(
        G,
        {
          id: "title",
          name: "title",
          type: "text",
          size: "medium",
          placeholder: "Enter title...",
          value: m.title,
          onChange: (g) => {
            C((A) => ({ ...A, title: g.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "parent", textLabel: "Tenant", required: !0, children: /* @__PURE__ */ t.jsx(
        ne,
        {
          className: "",
          name: "parent",
          disablePortal: !0,
          id: "parent",
          disabled: !!m.id,
          options: o,
          value: m.parent,
          placeholder: "Select tenant",
          onChange: (g) => {
            C({ ...m, parent: g });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ t.jsx(
          Le,
          {
            study: {
              analysisTypes: m.analysisTypes
            },
            analysisTypes: x(m.parent),
            onChange: (g) => {
              C((A) => ({
                ...A,
                analysisTypes: g
              }));
            }
          }
        ),
        /* @__PURE__ */ t.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
        /* @__PURE__ */ t.jsx(
          v,
          {
            variant: "outlined",
            onClick: s,
            size: "small",
            startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ t.jsx(
          v,
          {
            disabled: i || T || h,
            onClick: l,
            variant: "contained",
            size: "small",
            color: "success",
            startIcon: i ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
            name: "save",
            children: n ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), ga = ({ analysisTypes: e }) => {
  const s = Q(), { openModal: n, closeModal: a } = M(ae), { path: r, subModules: c } = M(
    B
  ), { enqueueSnackbar: o } = z(), i = Ve(
    (j) => j.user
  ), { tenants: d, groups: p, updateGroups: m, deleteGroups: C } = He(
    i.data
  ), l = Ce("Users", ha);
  L(() => {
    s(
      ee([
        {
          name: "Settings",
          path: `${r}`
        },
        {
          name: "User Groups",
          path: `${r}/groups`
        }
      ])
    );
  }, [r]);
  const h = async (j, g) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        be,
        {
          onClose: a,
          tenantId: j,
          hasParent: g,
          onChange: l,
          getList: Bn,
          getListByTenant: Lt,
          type: U.USERS
        }
      ),
      "Users",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, x = (j, g) => {
    n(
      () => /* @__PURE__ */ t.jsx(
        ya,
        {
          values: j,
          onClose: a,
          analysisTypes: e,
          currentAnalysisTypes: g,
          tenants: d.map((A) => ({
            value: A.id,
            name: A.title,
            ...A
          })),
          currentUser: i,
          onFinish: (A) => {
            m(A), o({
              message: j ? "User group changed" : "User group created",
              variant: "success"
            }), a();
          }
        }
      ),
      j ? "Change User Group" : "Create User Group",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: a
      }
    );
  }, T = O(async (j) => {
    try {
      await $n(j), C(j), o({
        message: "User Group deleted",
        variant: "success"
      });
    } catch (g) {
      console.error(g);
    }
  }, []), S = F(() => ma(h, T), []);
  return ce.useEffect(() => {
    document.title = "Prometheus - User Groups";
  }, []), /* @__PURE__ */ t.jsx(u, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
    /* @__PURE__ */ t.jsx(
      Te,
      {
        title: "User Groups",
        canCreate: d.length > 0,
        onCreate: () => x(),
        createButtonName: "Create User Group"
      }
    ),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      le,
      {
        columns: S,
        data: p,
        loadingMessage: "Loading...",
        totalElements: p.length,
        hideSettings: !0,
        onRowClick: async (j) => {
          const g = await wt(
            j.original.id
          );
          x(j.original, g);
        }
      }
    ) })
  ] }) });
}, xa = (e, s) => [
  {
    header: "Name",
    accessorKey: "name",
    size: 120,
    maxSize: 240
  },
  {
    header: "Code",
    accessorKey: "code",
    size: 120,
    maxSize: 240
  },
  {
    header: "Analysis Types",
    accessorFn: (n) => {
      var a, r;
      return (r = (a = n.relations) == null ? void 0 : a.analysisTypes) == null ? void 0 : r.map(
        (c) => {
          var o;
          return (o = e == null ? void 0 : e.find((i) => i.type === (c.type || c))) == null ? void 0 : o.name;
        }
      );
    },
    cell: Ee,
    enableSording: !1,
    size: 300
  },
  {
    header: "",
    accessorKey: "id",
    enableSording: !1,
    enableResizing: !1,
    maxSize: 100,
    size: 40,
    meta: { columnType: "action" },
    cell: (n) => {
      var a, r;
      return (r = (a = n.row.original) == null ? void 0 : a.actions) != null && r.delete ? /* @__PURE__ */ t.jsx(
        xe,
        {
          entityType: n.row.original.name,
          withConfirmation: !0,
          onRemove: () => s(n.row.original.code)
        }
      ) : /* @__PURE__ */ t.jsx(t.Fragment, {});
    }
  }
], Ta = V(
  (e) => {
    var T, S, j;
    const { onClose: s, values: n, analysisTypes: a, onFinish: r, isChange: c } = e, [o, i] = E(!1), { enqueueSnackbar: d } = z(), [p, m] = E({
      id: n == null ? void 0 : n.id,
      name: (n == null ? void 0 : n.name) || "",
      code: (n == null ? void 0 : n.code) || "",
      analysisTypes: ((S = (T = n == null ? void 0 : n.relations) == null ? void 0 : T.analysisTypes) == null ? void 0 : S.map((g) => g.type)) || [],
      deletedAnalysisTypes: []
    }), C = !c || ((j = n == null ? void 0 : n.actions) == null ? void 0 : j.update), l = O(async () => {
      try {
        const g = await Promise.all(
          as(p.code, p.analysisTypes)
        ), A = await Promise.all(
          p.deletedAnalysisTypes.map(
            (N) => rs(N, p.code)
          )
        );
        return {
          resUpdate: g,
          resDelete: A
        };
      } catch {
        return [];
      }
    }, [p]), h = O(async () => {
      i(!0);
      try {
        const g = await ns(p.code, {
          name: p.name,
          analysisTypes: p.analysisTypes
        });
        await l(), r({
          ...g,
          actions: {
            ...n.actions,
            delete: p.analysisTypes.length === 0
          },
          relations: {
            analysisTypes: p.analysisTypes
          }
        }), i(!1);
      } catch (g) {
        await l(), r(
          {
            ...p,
            relations: {
              analysisTypes: p.analysisTypes
            }
          },
          g
        ), i(!1);
      }
    }, [p]), x = F(() => !p.name || !(c || p.code), [p]);
    return /* @__PURE__ */ t.jsx(u, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(X, { children: /* @__PURE__ */ t.jsxs(u, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ t.jsx(
        G,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          placeholder: "Enter name",
          disabled: !C,
          value: p.name,
          onChange: (g) => {
            m((A) => ({ ...A, name: g.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(I, { name: "code", textLabel: "Code", required: !0, children: /* @__PURE__ */ t.jsx(
        G,
        {
          id: "code",
          name: "code",
          type: "text",
          size: "medium",
          placeholder: "Enter code",
          disabled: c,
          value: p.code,
          onChange: (g) => {
            m((A) => ({ ...A, code: g.target.value }));
          },
          fullWidth: !0,
          required: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(I, { name: "name", textLabel: "Analysis Types" }),
        /* @__PURE__ */ t.jsx(
          Le,
          {
            isLogger: !0,
            study: p,
            analysisTypes: a,
            onChangeLogger: ({ updated: g, deleted: A }) => {
              m((N) => ({
                ...N,
                analysisTypes: g,
                deletedAnalysisTypes: A
              }));
            }
          }
        ),
        /* @__PURE__ */ t.jsx(Ne, { sx: { mt: 2 } })
      ] }),
      /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(H, { children: [
        /* @__PURE__ */ t.jsx(
          v,
          {
            variant: "outlined",
            onClick: s,
            startIcon: /* @__PURE__ */ t.jsx(_, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ t.jsx(
          v,
          {
            disabled: o || x,
            onClick: h,
            variant: "contained",
            color: "success",
            startIcon: o ? /* @__PURE__ */ t.jsx(Z, { size: 16 }) : /* @__PURE__ */ t.jsx(_, { iconName: "submit" }),
            name: "save",
            children: n ? "Change" : "Create"
          }
        )
      ] }) })
    ] }) }) });
  }
), ja = (e) => {
  const { analysisTypes: s } = e, n = Q(), { openModal: a, closeModal: r } = M(ae), [c, o] = E([]), [i, d] = E([]), { path: p } = M(
    B
  ), { enqueueSnackbar: m } = z();
  L(() => {
    Ot().then((x) => {
      o(x.content), d(x.actions);
    });
  }, []), L(() => {
    n(
      ee([
        {
          name: "Settings",
          path: `${p}`
        },
        {
          name: "Model Types",
          path: `${p}/model-types`
        }
      ])
    );
  }, [p]);
  const C = (x, T) => {
    a(
      () => /* @__PURE__ */ t.jsx(
        Ta,
        {
          values: x,
          isChange: T,
          analysisTypes: s,
          onFinish: (S, j) => {
            const g = [...c], A = g.findIndex(
              (N) => N.code === S.code
            );
            A !== -1 ? g.splice(A, 1, S) : g.unshift(S), o(g), m(j ? {
              message: j.message,
              variant: "error"
            } : {
              message: x ? "Model type changed" : "Model type created",
              variant: "success"
            }), r();
          },
          onClose: r
        }
      ),
      x ? "Change Model Type" : "Create Model Type",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: r
      }
    );
  }, l = O(
    async (x) => {
      const T = [...c];
      try {
        await ss(x);
        const S = T.findIndex((j) => j.code === x);
        T.splice(S, 1), o(T), m({
          message: "Model type deleted",
          variant: "success"
        });
      } catch (S) {
        console.error(S), m({
          message: S.message,
          variant: "error"
        });
      }
    },
    [c]
  ), h = F(() => xa(s, l), [c]);
  return ce.useEffect(() => {
    document.title = "Prometheus - Model Types";
  }, []), /* @__PURE__ */ t.jsx(u, { container: !0, px: 6, pb: 2, bgcolor: "common.white", children: /* @__PURE__ */ t.jsxs(u, { item: !0, xs: 12, children: [
    /* @__PURE__ */ t.jsx(
      Te,
      {
        title: "Model Types",
        canCreate: i.find((x) => x === "create"),
        onCreate: () => C(),
        createButtonName: "Create Model Type"
      }
    ),
    /* @__PURE__ */ t.jsx(u, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      le,
      {
        columns: h,
        data: c,
        loadingMessage: "",
        hideSettings: !0,
        totalElements: c.length,
        onRowClick: async (x) => {
          const T = await ts(x.original.code);
          C(T, !0);
        }
      }
    ) })
  ] }) });
}, Sa = {
  rowId: "id",
  loadingMessage: "Loading audit logs...",
  tableTitle: "Audit Logs",
  listInitialSort: { id: "timestamp", desc: !0 },
  createCrudMethod: () => _e(
    null,
    null,
    (e) => os(e).then(Ca)
  ),
  createFiltersPanel: () => ve(null, null, cs),
  createSortingMethod(e) {
    return we(e, {
      getSorting: ls
    });
  },
  cols: [
    Xt(),
    Zt({
      header: "User",
      accessorFn: (e) => e.actor.name || e.actor.email,
      id: "actor.name",
      size: 140
    }),
    {
      header: "Event",
      accessorKey: "type"
    },
    {
      header: "Description",
      accessorFn: (e) => Qt(e.content, e.id),
      size: 500,
      cell: ({
        renderValue: e
      }) => e()
    }
  ]
};
an.TENANT_USER_REMOVED + "";
function Ca(e) {
  return !e || !e.content || !e.content.length ? e : {
    ...e,
    content: e.content.map((s) => ({
      ...s,
      affectedEntities: s.content.reduce((n, a) => {
        if (typeof a != "string") {
          const [r, c] = Object.entries(a)[0], [o, i] = Object.entries(c)[0];
          n.push({ id: o, type: r, title: i });
        }
        return n;
      }, [])
    }))
  };
}
const ba = (e) => {
  const s = M(
    B
  );
  return /* @__PURE__ */ t.jsx(u, { container: !0, children: /* @__PURE__ */ t.jsx(
    fe,
    {
      moduleConfig: s,
      listConfig: Sa,
      uniqName: "audit-log",
      disableRowClick: !0,
      exportFilteredResultsEnabled: !0,
      onExport: is
    }
  ) });
}, Aa = () => {
  const { state: e, status: s } = on(ds), { original: n, status: a } = cn(
    {}
  ), r = sa(!!(e != null && e.content));
  return [w.INITIAL, w.IN_PROGRESS].includes(s) && [w.INITIAL, w.IN_PROGRESS].includes(a) ? /* @__PURE__ */ t.jsx(en, { children: /* @__PURE__ */ t.jsx(Z, { size: 62 }) }) : /* @__PURE__ */ t.jsx(ca, { tabs: r, children: /* @__PURE__ */ t.jsxs(ht, { children: [
    /* @__PURE__ */ t.jsx(q, { index: !0, element: /* @__PURE__ */ t.jsx(Zs, { analysisTypes: n }) }),
    /* @__PURE__ */ t.jsx(
      q,
      {
        path: "groups",
        element: /* @__PURE__ */ t.jsx(ga, { analysisTypes: n })
      }
    ),
    /* @__PURE__ */ t.jsx(
      q,
      {
        path: "study-types",
        element: /* @__PURE__ */ t.jsx(pa, { analysisTypes: n })
      }
    ),
    /* @__PURE__ */ t.jsx(
      q,
      {
        path: "model-types",
        element: /* @__PURE__ */ t.jsx(ja, { analysisTypes: n })
      }
    ),
    /* @__PURE__ */ t.jsx(q, { path: "metadata", element: /* @__PURE__ */ t.jsx(js, {}) }),
    /* @__PURE__ */ t.jsx(q, { path: "data-sources", element: /* @__PURE__ */ t.jsx(na, {}) }),
    /* @__PURE__ */ t.jsx(q, { path: "data-nodes", element: /* @__PURE__ */ t.jsx(oa, {}) }),
    /* @__PURE__ */ t.jsx(q, { path: "users", element: /* @__PURE__ */ t.jsx(Cs, {}) }),
    /* @__PURE__ */ t.jsx(
      q,
      {
        path: "analysis-settings",
        element: /* @__PURE__ */ t.jsx(ia, { list: e == null ? void 0 : e.content })
      }
    ),
    /* @__PURE__ */ t.jsx(q, { path: "audit-logs", element: /* @__PURE__ */ t.jsx(ba, {}) })
  ] }) });
}, B = qt(null), fa = (e) => {
  const { path: s, title: n, name: a, rootSettings: r, initStorage: c, getHealthCheck: o } = e, [i, d] = E(r), [p, m] = E(!0);
  return L(() => {
    r || d({
      rootPath: s,
      rootTitle: n
    }), m(!1), document.title = "Prometheus - Settings";
  }, []), p ? /* @__PURE__ */ t.jsx(yt, { children: /* @__PURE__ */ t.jsx(Z, { size: 32 }) }) : /* @__PURE__ */ t.jsx(
    B.Provider,
    {
      value: { ...e, rootSettings: i, getHealthCheck: o },
      children: /* @__PURE__ */ t.jsx(ht, { children: /* @__PURE__ */ t.jsx(q, { path: "/*", element: /* @__PURE__ */ t.jsx(Aa, {}) }) })
    }
  );
}, Pa = (e) => {
  const { type: s } = e;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    !s && /* @__PURE__ */ t.jsx(fa, { ...e }),
    s === "component" && /* @__PURE__ */ t.jsx(An, { ...e })
  ] });
};
export {
  Pa as Admin
};
